<template>
  <header class="header mb-40">
    <div class="header__inner container h-100">
      <div class="flex-x-between flex-y-center">
        <h1>
          <logo link />
        </h1>
        <div class="d-sm-none">
          <hamburger />
        </div>
      </div>
      <user-panel />
    </div>
  </header>
</template>

<script>
  import Logo from '@/components/Logo'
  import UserPanel from '@/components/UserPanel'
  import Hamburger from '@/components/Hamburger'

  export default {
    name: 'Header',

    components: {
      Logo,
      UserPanel,
      Hamburger
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    background: #fff;
    box-shadow: $box-shadow-md;
    height: 100px;
    min-height: 100px;
    padding-bottom: 8px;
    @media (min-width: $viewport-sm) {
      height: 80px;
      min-height: 80px;
      padding-bottom: 0;
    }
  }
  .header__inner {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    @media (min-width: $viewport-sm) {
      flex-direction: row;
      align-items: center;
    }
  }
</style>
